export default __webpack_public_path__ + "static/pushkar-e26faa67717d136c8f84948aef00175d.png";